
import { i18n } from 'plugins/i18n.js'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      min_period_date: 'getMinPproposalsDate',
    }),
    available_days() {
      let days = this.$store.getters.getHolidays
      return days
    },
    min_date() {
      let time = moment()
      if (this.min_period_date) {
        time = moment(this.min_period_date)
      }

      time.set('hour', '15')
      time.set('minute', '00')
      time.set('second', '00')

      if (time < this.min_period_date) {
        while (!this.$_allowedDates(time)) {
          time.add(1, 'd')
        }
      }

      return time
    },
    proposals_min() {
      let time = this.min_period_date
      if ( time && moment(this.proposals_date || this.formData?.proposal?.date || this.endDate).format('YYYY-MM-DDHH:mm') < time?.format('YYYY-MM-DDHH:mm')) {
        return time
      }
    },
    periods() {
      return [
        {
          name: this.$t('Purchasing.InWeek'),
          type: 'week',
        },
        {
          name: this.$t('Purchasing.PerMonth'),
          type: 'month',
        },
        {
          name: this.$t('Purchasing.InYear') ,
          type: 'year',
        },
        {
          name: this.$t('Purchasing.SelectPeriod'),
        },
      ]
    },
  },
  methods: {
    $_allowedDates(val, return_type) {
      let value =  moment(val).format('YYYY-MM-DD'),
        day = this.available_days?.find(date =>  moment(date.date).format('YYYY-MM-DD') == value )
      if (!day) {
        return moment(val).isoWeekday() < 5
      }
      return return_type ?  day.dayType : day.dayType == 'WORK_DAY'
    },
    /**
     * По идее, не используется
    * deprecation
    */
    $_disableMonthBtns() {
      setTimeout(() => {
        let btns = document.querySelectorAll('.v-date-picker-header__value button')
        btns.forEach(btn => btn.disabled = true)
      }, 500)
    },
    getText(from, to) {
      if (!from && !to) {
        return this.$t('Purchasing.AllTheTime')
      }
      let res = this.periods.find( period => {
        return period.type && moment().format('YYYY-MM-DD') == moment(to).format('YYYY-MM-DD')
          && moment().subtract(1, period.type).format('YYYY-MM-DD') == from
      })
      if (res) {
        return res.name
      } else if (from == to) {
        return i18n.d(new Date(from), 'shortDate')
      } else {
        return i18n.d(new Date(from), 'shortDate') + ' - ' +  i18n.d(new Date(to), 'shortDate')
      }
    },
    $_perPeriod(period) {
      if ( this.set_future_terms ) {
        this.period = [moment().format('YYYY-MM-DD'), moment().add(1, period).format('YYYY-MM-DD') ]
      } else {
        this.period = [moment().subtract(1, period).format('YYYY-MM-DD'),  moment().format('YYYY-MM-DD') ]
      }

      if (this.$refs['date-picker-pair'] ) {
        this.$refs['date-picker-pair'].month = moment().format('YYYY-MM')
      }
    },
    $_customizeMonths() {
      this.$nextTick(() => {
        let table = this.$el,
          tds = table.querySelectorAll('td ')
        this.$_.forEach( tds, td => {
          let
            className = moment( (this.year || moment(this.month_sync).format('Y')) + '-' + ((td.cellIndex + 1 ) + (td.parentNode.rowIndex * 3 ))).format('YYYY-MM') ,
            btn = td.firstChild

          if ( td.classList.length ) {
            td.classList.remove( td.classList[0] )
          } else {
            td.classList.add( className )
          }

          if (!btn) { return }

          if ( this.period_sync?.length) {
            btn.classList.remove('rounded')
            btn.classList.remove('from')
            btn.classList.remove('to')
            btn.classList.remove('active')

            let check = date => moment( date ).format('YYYY-MM')  == className

            if ( typeof this.period_sync == 'string') {
              if ( check(this.period_sync) ) {
                btn.classList.add('rounded')
              }
            } else if ( (check(this.period_sync[0] ) && check(this.period_sync[1]) )
              || (!this.period_sync[1] && check(this.period_sync[0] ))
              || (!this.period_sync[0] && check(this.period_sync[1])) ) {
              btn.classList.add('rounded')
            } else if ( check(this.period_sync[0] )  ) {
              btn.classList.add('from')
            } else if ( check(this.period_sync[1] )  ) {
              btn.classList.add('to')
            }
          }
        })
      })
    }
  }
}
